export default {
  stat: null,
  monthly_stats: [],
  template_stats: [],
  total: 0,
  limit: 5
}
